import PocketBase from 'pocketbase';

export const pbUrl = 'https://api.streetwall.art';
export const pb = new PocketBase(pbUrl);

pb.autoCancellation(false);

// Утилита для получения или создания анонимного ID
export const getAnonId = () => {
  if (typeof window === 'undefined') return 'server';
  let anonId = localStorage.getItem('sw:anon_id');
  if (!anonId) {
    anonId = 'anon_' + Math.random().toString(36).substring(2, 9);
    localStorage.setItem('sw:anon_id', anonId);
  }
  return anonId;
};
export const getUserPlan = () => {
    if (typeof window === 'undefined') return 'bomber';
    // Potential tiers: 'bomber' (base), 'streetart' (pro)
    return localStorage.getItem('sw:user_plan') || 'bomber';
};

// Флаг: коллекция user_profile недоступна (403) — пропускаем повторные запросы
let _userProfileUnavailable = false;

/**
 * Загружает профиль пользователя из PocketBase по user_id.
 * @param {string} userId — anonId или TON-адрес
 * @returns {object|null} запись профиля или null
 */
export const getUserProfile = async (userId) => {
    if (!userId || _userProfileUnavailable) return null;
    try {
        const records = await pb.collection('user_profile').getList(1, 1, {
            filter: `user_id="${userId}"`
        });
        const profile = records.items[0] || null;

        // Fetch privileges directly from user_privileges collection
        try {
            const privRecords = await pb.collection('user_privileges').getList(1, 1, {
                filter: `user_id="${userId}"`
            });
            const privileges = privRecords.items[0] || null;
            if (privileges) {
                if (!profile) {
                    return {
                        user_id: userId,
                        role: privileges.role,
                        paymentBypass: privileges.paymentBypass,
                        promoMode: privileges.promoMode
                    };
                }
                profile.role = privileges.role;
                profile.paymentBypass = privileges.paymentBypass;
                profile.promoMode = privileges.promoMode;
            }
        } catch (privErr) {
            // Ignore privileges fetch error
        }

        return profile;
    } catch (err) {
        if (err?.status === 403) _userProfileUnavailable = true;
        return null;
    }
};

/**
 * Создаёт или обновляет профиль пользователя в PocketBase.
 * Отправляет user_name и user_place как JSON.
 * Если avatarBlob передан — отправляет его как файл через FormData.
 *
 * @param {string} userId — anonId или TON-адрес
 * @param {{ user_name: string, user_place: string }} textData — текстовые поля
 * @param {Blob|null} avatarBlob — бинарный файл аватара (или null)
 * @returns {object|null} сохранённая запись или null
 */
export const saveUserProfile = async (userId, textData, avatarBlob = null) => {
    if (!userId || _userProfileUnavailable) return null;
    try {
        // Ищем существующую запись
        const records = await pb.collection('user_profile').getList(1, 1, {
            filter: `user_id="${userId}"`,
        });
        const existing = records.items[0];

        let payload;
        if (avatarBlob) {
            // Если есть файл — используем FormData
            payload = new FormData();
            payload.append('user_id', userId);
            payload.append('user_name', textData.user_name || '');
            payload.append('user_place', textData.user_place || '');
            payload.append('user_avatar', avatarBlob, 'avatar.jpg');
        } else {
            // Только текстовые поля — JSON
            payload = { user_id: userId, ...textData };
        }

        if (existing) {
            return await pb.collection('user_profile').update(existing.id, payload);
        } else {
            return await pb.collection('user_profile').create(payload);
        }
    } catch (err) {
        if (err?.status === 403) _userProfileUnavailable = true;
        return null;
    }
};

// ── Хелперы для аватара в localStorage ──────────────────────────────
// Аватар (режим + данные) хранится локально, PocketBase хранит только файл.
const LS_AVATAR = 'sw:avatar_v1'; // JSON: { mode, preset, dataUrl }

export const loadLocalAvatar = () => {
    if (typeof window === 'undefined') return null;
    try { return JSON.parse(localStorage.getItem(LS_AVATAR)) || null; } catch { return null; }
};

export const saveLocalAvatar = (avatarObj) => {
    if (typeof window === 'undefined') return;
    try { localStorage.setItem(LS_AVATAR, JSON.stringify(avatarObj)); } catch { /* noop */ }
};
